module.exports = __webpack_public_path__ + "img/003-car-insurance.01190e17.svg";